import { useCallback, useState } from 'react';

export interface AnchorPosition {
  top: number;
  left: number;
}

export const useActionMenu = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [anchorPosition, setAnchorPosition] = useState<AnchorPosition | null>(null);

  const openMenu = useCallback((element: HTMLElement) => {
    // Capture position at open time before any re-renders can affect the element
    const rect = element.getBoundingClientRect();
    setAnchorPosition({
      top: rect.bottom,
      left: rect.right,
    });
    setAnchorEl(element);
  }, []);

  const closeMenu = useCallback(() => {
    setAnchorEl(null);
    setAnchorPosition(null);
  }, []);

  return {
    anchorEl,
    anchorPosition,
    isOpen: Boolean(anchorEl),
    openMenu,
    closeMenu,
  };
};
